import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  observations?: string
}

const OtherContractInformation = ({ observations }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.other_information.observations')}
      description={observations}
    />
  )
}

export default OtherContractInformation
